<template>
  <template v-if="getShow">
    <template v-if="getShowHeader">
      <section class="flex justify-between content-end">
        <LoginFormTitle class="enter-x" />
        <a
          :class="`${prefixCls}-link flex flex-row items-center !text-[var(--primary-color-2)]`"
          @click="handleBackLogin"
        >
          {{ t('sys.login.backSignIn') }}
        </a>
      </section>
      <section class="mb-6 flex !bg-[#1D2129] rounded-lg p-2">
        <template v-for="(option, index) in stepTypes" :key="index">
          <StepStart
            v-if="index === 0"
            :active="getForgetPassState === option.value"
            class="flex-1 step"
          >
            <span class="mr-2 ml-1">{{ option.label }}</span>
          </StepStart>
          <StepEnd
            v-else-if="index === stepTypes.length - 1"
            :active="getForgetPassState === option.value"
            class="flex-1 step"
          >
            <span class="mr-2 ml-1">{{ option.label }}</span>
          </StepEnd>
          <StepIng v-else :active="getForgetPassState === option.value" class="flex-1 step">
            <span class="mr-2 ml-1">{{ option.label }}</span>
          </StepIng>
        </template>
      </section>
    </template>
    <ForgetPasswordFormEmail />
    <ForgetPasswordFormReset />
    <ForgetPasswordFormSuccess />
  </template>
</template>
<script lang="ts" setup>
  import { computed, unref } from 'vue';
  import LoginFormTitle from './LoginFormTitle.vue';
  import { StepStart, StepIng, StepEnd } from '/@/components/Business/Steps';
  import { useI18n } from '@mcex/locale';
  import {
    useLoginState,
    LoginStateEnum,
    useForgetPassState,
    ForgetPassStateEnum,
  } from './useLogin';
  import { useDesign } from '/@/hooks/web/useDesign';
  import ForgetPasswordFormEmail from './ForgetPasswordFormEmail.vue';
  import ForgetPasswordFormReset from './ForgetPasswordFormReset.vue';
  import ForgetPasswordFormSuccess from './ForgetPasswordFormSuccess.vue';

  const { prefixCls } = useDesign('link');
  const { t } = useI18n();

  const { handleBackLogin, getLoginState } = useLoginState();
  const { getForgetPassState } = useForgetPassState();

  const getShow = computed(() =>
    // 重置密码和强制重置密码都显示,会员端跳转时在路由传递参数FORCE_RESET_PASSWORD
    [LoginStateEnum.RESET_PASSWORD, LoginStateEnum.FORCE_RESET_PASSWORD].includes(
      unref(getLoginState),
    ),
  );
  const getShowHeader = computed(() => unref(getForgetPassState) !== ForgetPassStateEnum.SUCCESS);

  const stepTypes = computed(() => {
    return [
      {
        label: t('sys.login.verifyEmailNum'),
        value: ForgetPassStateEnum.CHECK_EMAIL,
      },
      {
        label: t('sys.login.setNewPassword'),
        value: ForgetPassStateEnum.RESET_PASSWORD,
      },
      {
        label: t('sys.login.passwordResetSucceeded'),
        value: ForgetPassStateEnum.SUCCESS,
      },
    ];
  });
</script>
<style lang="less" scoped>
  @link-cls: ~'@{namespace}-link';
  .@{link-cls} {
    color: @other-link-color;
  }

  :deep .step {
    & > div {
      justify-content: center !important;
    }
  }
</style>
